import { crudActions, crudMutations, crudGetters } from "@/utils/store";

const BASE_URL = `${process.env.BASE_URL_V2}/admin/backgrounds/`
const BASE_URL_PUBLIC = `${process.env.BASE_URL_V2}/public/backgrounds/`

export const state = () => ({
  objects: [],
  total: 0,
  publicObjects: [],
  publicTotal: 0,
})

export const mutations = {
  ...crudMutations,
  SET_PUBLIC_OBJECTS(state, payload) {
    state.publicObjects = payload.publicObjects.map(x => {
      x.key = x.idx
      return x
    });
    state.publicTotal = payload.publicTotal;
  },
}

export const actions = {
  ...crudActions(BASE_URL),
  async fetchPublicObjects({ commit }, params = {}) {
    const response = await this.$axios.$get(BASE_URL_PUBLIC, { params: params })
    commit('SET_PUBLIC_OBJECTS', { publicObjects: response['items'], publicTotal: response['total'] })
    return response
  },
  async fetchPublicObject({}, id) {
    return this.$axios.$get(`${BASE_URL_PUBLIC}${id}/`)
  },
}

export const getters = { ...crudGetters }
